import { render } from "./ProsesUser.vue?vue&type=template&id=6b3d21fc"
import script from "./ProsesUser.vue?vue&type=script&lang=js"
export * from "./ProsesUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__